import type { GeneralConfig } from '@shared/types/Config';

export const blockConfig: GeneralConfig = {
    sortFieldMap: {
        'transaction.data.transaction_code': 'transactions|transaction_code',
        'inventory.data.inventory_code': 'inventories|inventory_code',
    },
};
